import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* getAssignmentSummary({ payload: { signal, id, onSuccess } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.assignments.summary, id, signal });

    onSuccess && onSuccess(data.result);
    yield put(actions.getAssignmentSummaryDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getAssignmentSummaryFailed,
      endpoint: api.modifiers.assignments.summary.url
    });
  }
}

export const getAssignmentSummarySaga = takeEvery(types.GET_ASSIGNMENT_SUMMARY_REQUEST, getAssignmentSummary);